import React, { createContext, useState } from "react";

export const UserContext = createContext(); 

export const UserProvider = ({ children }) => {
  const [userInfo,setUserInfo] = useState({projects:[], characters:[], firstName:'', lastName:'', email:'', tokens:0}) //remove data before launch
    
  return (
    <UserContext.Provider value={{ userInfo, setUserInfo }}>
      {children} 
    </UserContext.Provider>
  );
};
